import { Injectable } from '@angular/core'
import { GlobalEventNameEnum } from './global-events.types'

@Injectable({ providedIn: 'root' })
export class GlobalEventsService {
  public dispatchEvent(name: GlobalEventNameEnum, detail?: Record<string, any>): void {
    const event = new CustomEvent(name, { detail })
    window.dispatchEvent(event)
  }
}
